// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill"
import Vue from 'vue'
import App from './App'
import 'directive'
import router from './router'
import Layer from "lib/vue-layer-mobile"
//import 'vue-layer-mobile/need/layer.css'
//import Layer from 'vue-layer-mobile'
import {NetworkException, ResponseException} from 'lib/Exception'

Vue.use(require('vue-touchjs'));
Vue.use(require('vue-lazy-load-img'))
Vue.use(require('vue-wechat-title'))
Vue.use(Layer);

/* eslint-disable no-new */
const app = new Vue({
  el: '#app',
  router,
  template: '<App ref="app"/>',
  components: {App}
});


window.onunhandledrejection = function (event) {
    if (!DEBUG) {
      event.preventDefault && event.preventDefault();
    }
    let {promise} = event,
      {$layer} = app;
    promise.catch(ex => {
      if(DEBUG){
          console.log('系统错误==========================');
          console.log(ex);
      }
      if (ex instanceof NetworkException) {
        //$layer.toast("系统正忙，请稍后再试");
        if(ex.message.code){
            $layer.toast("系统正忙，请稍后再试【"+ex.message.code+"】："+ex.message.message);
        }else{
            $layer.toast("系统正忙，请稍后再试："+ex.message.message);
        }
      } else if (ex instanceof ResponseException) {
        let {errcode, errmsg} = ex.message;
        if (errcode >= 3000 && errcode <= 3999) {
          $layer.toast(errmsg);
        } else if (errcode >= 5000 && errcode <= 5999) {
          $layer.dialog({
            content: errmsg,
            btn: ["知道了"]
          })
        }
      }
    })
  }



// WEBPACK FOOTER //
// ./src/main.js